import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "table-responsive" }
const _hoisted_2 = { class: "table table-row-dashed table-row-gray-300 align-middle" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted" }, [
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-150px" }, "Type"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-140px" }, "When"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { class: "min-w-120px text-end" }, "IP address")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ActivityTableRow = _resolveComponent("ActivityTableRow")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.tableData, (activity) => {
          return (_openBlock(), _createBlock(_component_ActivityTableRow, {
            key: activity.id,
            entry: activity
          }, null, 8, ["entry"]))
        }), 128))
      ])
    ])
  ]))
}